<template>
    <div >
        <v-row dense class="ma-0">
            <v-col cols="2">
            </v-col>
            <v-col cols="10">
                <h3 class="elementTitle">
                    <span>{{ title }}</span>
                </h3>
            </v-col>
        </v-row>
        <v-divider/>
        <v-row dense class="ma-0">
            <v-col cols="2" class="iconCol pt-2">
                <div>
                    <v-icon v-if="useSmallIcon">{{ icon }}</v-icon>
                    <v-icon class="adminIconLarge" v-else large>{{ icon }}</v-icon>
                </div>
            </v-col>
            <v-col cols="10">
                <span class="adminDescription" v-html="description"></span>
            </v-col>
        </v-row>
        <v-row dense class="ma-0" v-if="showPeriod && dateRangeSelect">
            <v-col cols="2"></v-col>
            <v-col cols="10">
                <date-range-picker @dateRangeChanged="dateRangeChanged" :disabled="disabled"/>
            </v-col>
        </v-row>
        <v-row dense class="ma-0" v-else-if="showPeriod && weekSelect">
            <v-col cols="2"></v-col>
            <v-col cols="10">
                <week-date-picker @weekChanged="weekChanged" :disabled="disabled"/>
            </v-col>

        </v-row>
        <v-row dense class="ma-0" v-else-if="showPeriod">
            <v-col cols="2"></v-col>
            <v-col cols="10">
                <v-select flat solo @change="showReport" item-text="text" item-value="id" :items="periodItems"
                          v-model="period" v-if="!disabled" />
            </v-col>
        </v-row>
        <v-row dense class="ma-0" v-else>
            <v-col cols="2"></v-col>
            <v-col cols="10">
                <v-btn v-if="route" text class="adminGotoLink pl-0" :to="route">
                    <span v-if="linkText">
                        {{ linkText }}
                    </span>
                    <span v-else>
                    anzeigen
                        </span>
                </v-btn>
                <v-btn v-else text class="adminGotoLink pl-0" @click="showReport">
                    <span v-if="linkText">
                        {{ linkText }}
                    </span>
                    <span v-else>
                    anzeigen
                        </span>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WeekDatePicker from "@/components/general/WeekDatePicker.vue";
import DateRangePicker from "@/components/general/DateRangePicker.vue";

@Component({
    components: {WeekDatePicker, DateRangePicker}
})
export default class ReportElement extends Vue {
    private dates:[] =[];
    private get dateRangeText () {
        return this.dates.join(' ~ ')
    }
    private disabled: boolean=false;
    @Prop()
    private linkText!: string | null;
    @Prop()
    private route!: string | null;
    @Prop() useSmallIcon!: boolean;
    @Prop({required: true}) title!: string;
    @Prop({required: true}) description!: string;
    @Prop({required: true}) icon!: string;
    @Prop({required: true}) reportNr!: any;
    @Prop({required: true}) reportUrl!: string;
    @Prop({default: true}) showPeriod!: boolean;
    @Prop({default: false}) weekSelect!: boolean;
    @Prop({default: false}) dateRangeSelect!: boolean;
    private period: number = 0;
    private periodItems: { id: number, text: string }[] = [{id: 0, text: 'Bitte wählen'}, {
        id: 1,
        text: 'heute'
    }, {id: 2, text: 'aktuelle Woche'}, {id: 3, text: 'letzte 14 Tage'}, {id: 4, text: 'aktueller Monat'}];

    private async showReport() {
        if (this.period > 0 || !this.showPeriod) {
            await this.$emit('showReport', {
                reportUrl: this.reportUrl,
                reportNr: this.reportNr,
                period: this.period,
                showPeriod: this.showPeriod
            });
            this.period = 0;
        }
    }

    private async weekChanged(week: { week: number, year: number }): Promise<void> {
        await this.$emit('showWeekReport', {
            reportUrl: this.reportUrl,
            reportNr: this.reportNr,
            week: week,
            showPeriod: this.showPeriod
        });
        this.period = 0;
    }
    async mounted(){
        const config = JSON.parse(localStorage.getItem('Auth/userConfig')|| '');

       if(!this.route) {
           this.disabled = config.permissions.REPORTS === 0;
       }
    }

    private async dateRangeChanged(args: {start:Date, end:Date}){
        await this.$emit('showRangeReport', {
            reportUrl: this.reportUrl,
            reportNr: this.reportNr,
            start: args.start,
            end: args.end
        });
        this.period = 0;
    }
}
</script>

<style scoped>
.elementTitle > a {
    text-decoration: none;
    color: unset !important;
}

.iconCol > a {
    text-decoration: none;
}

.iconCol {
    text-align: center;
}

.adminIconLarge {
    font-size: 32px !important;
}

.adminDescription {

}

.adminGotoLink {
    padding-top: 6pt;
}
</style>
